module.exports = __webpack_public_path__ + "img/tt-bg.4c323854.png";